var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefabricFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8996_62699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6811 0H6.33398V6.44284H49.6811V0Z",
    fill: "#E88053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6733 49.5586H6.32617V56.0014H49.6733V49.5586Z",
    fill: "#E88053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32636 6.52344H0.0546875V49.5487H6.32636V6.52344Z",
    fill: "#E88053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6156 16.0273H15.2207V22.4223H21.6156V16.0273Z",
    fill: "#E88053"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3844 43.1562H40.7793V36.7613H34.3918V30.3732H27.9969H21.6088V36.7547H15.2207V43.1496H21.6156V36.7681H27.9969H34.3844V43.1562Z",
    fill: "#E88053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7797 16.0273H34.3848V22.4223H40.7797V16.0273Z",
    fill: "#E88053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9455 6.44141H49.6738V49.5557H55.9455V6.44141Z",
    fill: "#E88053"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8996_62699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.8904,
    height: 56,
    fill: "white",
    transform: "translate(0.0546875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefabricFail);
export default __webpack_public_path__ + "static/media/icon-refabric-fail.eda8eff6d38424bd6778513344179af8.svg";
export { ForwardRef as ReactComponent };